import { faIdCard, faToggleOn } from '@fortawesome/pro-light-svg-icons'

import type { SystemModel } from '@models/types'

import { generateUrls } from '@hooks/useSystem'

const generateTabBarItems = (system: SystemModel) => {
  const urls = generateUrls(system)
  const { editSystemUrl, editSystemRelationsUrl } = urls

  return [
    {
      icon: faIdCard,
      href: editSystemUrl,
      key: 'details',
      title: system?.title || 'System Details',
    },
    {
      icon: faToggleOn,
      href: editSystemRelationsUrl,
      key: 'relations',
      title: 'System Relations',
    },
  ]
}

export default generateTabBarItems
